import { useFlags } from 'flagsmith/react';

export const useIsPaymentsEnabled = (): boolean => {
  const { payments_enabled } = useFlags(['payments_enabled']);
  return payments_enabled?.enabled;
};
